import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "timestamp-generator" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Time Stamp Generator", -1)
const _hoisted_3 = {
  key: 0,
  class: "timestamp-display"
}
const _hoisted_4 = { class: "timestamp" }
const _hoisted_5 = {
  key: 1,
  class: "timestamp-display"
}
const _hoisted_6 = { class: "timestamp" }
const _hoisted_7 = {
  key: 2,
  class: "timestamp-display"
}
const _hoisted_8 = { class: "timestamp" }
const _hoisted_9 = {
  key: 3,
  class: "timestamp-display"
}
const _hoisted_10 = { class: "timestamp" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8" }, "Timestamp Converter", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, null, -1)
const _hoisted_13 = {
  key: 4,
  class: "timestamp-display"
}
const _hoisted_14 = { class: "timestamp" }
const _hoisted_15 = {
  key: 5,
  class: "timestamp-display"
}
const _hoisted_16 = { class: "timestamp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      class: "generate-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generateTimestamp && _ctx.generateTimestamp(...args)))
    }, "Generate Timestamp"),
    (_ctx.timestamps.iso)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, [
            _createTextVNode("ISO Format: "),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.timestamps.iso), 1)
          ]),
          _createElementVNode("button", {
            class: "copy-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyToClipboard(_ctx.timestamps.iso)))
          }, "Copy")
        ]))
      : _createCommentVNode("", true),
    (_ctx.timestamps.numeral)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _createTextVNode("Numeral Timestamp (ms): "),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.timestamps.numeral), 1)
          ]),
          _createElementVNode("button", {
            class: "copy-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyToClipboard(_ctx.timestamps.numeral)))
          }, "Copy")
        ]))
      : _createCommentVNode("", true),
    (_ctx.timestamps.seconds)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("p", null, [
            _createTextVNode("Unix Timestamp (s): "),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.timestamps.seconds), 1)
          ]),
          _createElementVNode("button", {
            class: "copy-btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyToClipboard(_ctx.timestamps.seconds)))
          }, "Copy")
        ]))
      : _createCommentVNode("", true),
    (_ctx.timestamps.timezone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("p", null, [
            _createTextVNode("Timezone: "),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.timestamps.timezone), 1)
          ]),
          _createElementVNode("button", {
            class: "copy-btn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyToClipboard(_ctx.timestamps.timezone)))
          }, "Copy")
        ]))
      : _createCommentVNode("", true),
    _hoisted_11,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userTimestamp) = $event)),
      placeholder: "Enter timestamp (ms or s)",
      class: "timestamp-input"
    }, null, 512), [
      [_vModelText, _ctx.userTimestamp]
    ]),
    _hoisted_12,
    _createElementVNode("button", {
      class: "convert-btn",
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.convertTimestamp && _ctx.convertTimestamp(...args)))
    }, "Convert"),
    (_ctx.convertedTimestamp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("p", null, [
            _createTextVNode("Human Readable: "),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.convertedTimestamp), 1)
          ]),
          _createElementVNode("button", {
            class: "copy-btn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.copyToClipboard(_ctx.convertedTimestamp)))
          }, "Copy")
        ]))
      : _createCommentVNode("", true),
    (_ctx.convertedUTCTimestamp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("p", null, [
            _createTextVNode("UTC Time: "),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.convertedUTCTimestamp), 1)
          ]),
          _createElementVNode("button", {
            class: "copy-btn",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copyToClipboard(_ctx.convertedUTCTimestamp)))
          }, "Copy")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["snackbar", { show: _ctx.showSnackbar }])
    }, "Copied to clipboard!", 2)
  ]))
}